export enum LinkTarget {
  SameTab = 'same',
  NewTab = 'new',
}
